import { render, staticRenderFns } from "./TurnView.vue?vue&type=template&id=d8b6e3a0&scoped=true&"
import script from "./TurnView.vue?vue&type=script&lang=js&"
export * from "./TurnView.vue?vue&type=script&lang=js&"
import style0 from "./TurnView.vue?vue&type=style&index=0&id=d8b6e3a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b6e3a0",
  null
  
)

export default component.exports